// extracted by mini-css-extract-plugin
module.exports = {"box":"style_box__HDgc0","typograph":"style_typograph__2PPvm","progressBar":"style_progressBar__1Nw8M"};